import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';
import * as _ from 'lodash';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McWhVariantService {

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  loadVariant(sku: string) {
    const query = { sku };
    return this.sdk.warehouse.variants().find(query);
  }

  /**
   * Load All Variants or Product Variants
   * @param organization 
   * @param productId 
   * @param filter - all, sellable, supplies
   */
  async loadVariants(organization: string, productId: string = undefined, filter: string = 'all') {
    let query: any = {
      $populate: {
        stock: {
          service: 'wh-stocks', key: 'sku', method: 'findOne', idField: 'variant',
          warehouse: organization
        }
      },
      branches: organization,
    };

    if (filter == 'sellable') {
      query['sellable'] = true;
    } else if (filter == 'supplies') {
      query['sellable'] = false;
    }

    if (productId) {
      // if querying all variants under a product
      query['product'] = productId;
    }

    const res = await this.sdk.warehouse.variants().find(query);
    let items: any[] = res.items;
    items = items.map(item => {
      item = this.createVariantId(item);
      return {
        ..._.omit(item, ['$populated']),
        quantity: (item.$populated.stock || {}).quantity || 0
      };
    });

    return items;
  }

  removeVariant(sku: string) {
    const query: any = { sku };
    return this.sdk.warehouse.variants().remove(sku, query)
  }

  /**
   * Create a temporary id
   * @param order 
   */
  private createVariantId(order: any) {
    if (order && order.sku) {
      const prefix = order.sku.substr(0, 3).toUpperCase();
      const suffix = order.sku.substr(-10).toUpperCase();
      const _id = `${prefix}-${suffix}`;
      return { _id, ...order };
    }

    return order;
  }
}
